import Error from '@/component/Empty/Error';
import { useTexts } from '@/feature/lang';
import { useReportsQuery } from '../api/queries';
import { Page } from '../components/Page';
import { RmsReport } from '../types';
import { ReportsTable } from './table/ReportsTable';

const empty: RmsReport[] = [];

export default function ReportPage() {
  const texts = useTexts().rms.reports;
  const { data = empty, isLoading, isError, refetch } = useReportsQuery();

  return (
    <Page title={texts.header}>
      {isError ? (
        <Error retry={() => refetch()} />
      ) : (
        <ReportsTable reports={data} isLoading={isLoading} />
      )}
    </Page>
  );
}
